import { Suspense, type ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { Notification } from "@/components/admin/notification";
import { Error } from "@/components/admin/error";
import { Skeleton } from "@/components/ui/skeleton";

import { DataImportProvider } from "../dataImport/DataImportProvider";
import { useConfigurationLoader } from "../root/useConfigurationLoader";
import { AppSidebar, AppTopBar } from "../construnario/AppSidebar";

// Construnario: sidebar layout (see construnario/AppSidebar.tsx) instead of
// Atomic's top navigation bar.
export const Layout = ({ children }: { children: ReactNode }) => {
  useConfigurationLoader();
  return (
    <DataImportProvider>
      <div className="grid min-h-screen grid-cols-[228px_minmax(0,1fr)]">
        <AppSidebar />
        <div className="flex min-w-0 flex-col">
          <AppTopBar />
          <main className="w-full max-w-screen-xl px-6 py-5" id="main-content">
            <ErrorBoundary FallbackComponent={Error}>
              <Suspense
                fallback={<Skeleton className="h-12 w-12 rounded-full" />}
              >
                {children}
              </Suspense>
            </ErrorBoundary>
          </main>
        </div>
      </div>
      <Notification />
    </DataImportProvider>
  );
};
